module.exports = __webpack_public_path__ + "img/shoopbox_kong_img@2x.4cc1ef9f.png";